import React from 'react';

import { SxProps } from '@material-ui/system';
import Box from '@mui/material/Box';

import { useSidebarWidth } from '~components/hooks/useSidebarWidth';

import { Footer } from '../../layout/footer';

interface Props {
  children: React.ReactNode;
  sx?: SxProps;
}

const AppPageWrapper = ({ children, sx }: Props) => {
  const sidebarWidth = useSidebarWidth();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'absolute',
        top: ['88px', 0],
        left: [0, sidebarWidth],
        right: 0,
        transition: 'left 0.15s linear',
        height: '100%',
        ...sx,
      }}
    >
      {children}
      <Footer />
    </Box>
  );
};

export default AppPageWrapper;
